import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { ActionTypes } from "../store/types";

import { Loader } from "../components/Loader";
import { Squad } from "../components/Squad";
import { ScoreItem } from "../components/ScoreItem";
import { ScoreNumber } from "../components/ScoreNumber";
import WithMotion from "../utils/withMotion";

import heartIcon from "../assets/icons/heart.svg";
import skullIcon from "../assets/icons/skull.svg";
import yourFinalScoreHeadline from "../assets/headlines/your-final-score.png";
import scss from "./YourScore.module.scss";

//Components
import { TotalPoints } from "../components/TotalPoints";

const YourScore = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { squadSubmission, score, theater } = useSelector(
    (state: any) => state
  );
  const { squad, entryId } = squadSubmission;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!score) {
      axios
        .get(`/get_score`, {
          params: { id: entryId },
        })
        .then(({ data }) => {
          dispatch({ type: ActionTypes.SET_SCORE, payload: data });
        })
        .catch((err) => {
          console.error(err);
          if (err.response.status === 404) {
            history.push("/");
          } else {
            console.error(err);
            history.push("/");
          }
        });
    }

    // eslint-disable-next-line
  }, []);

  if (!score) {
    return <Loader />;
  }

  (window as any).analytics?.track("Result Viewed", {
    entryId,
    score: score.totalPoints,
    rankings: score.rankings,
    theater,
  });

  return (
    <main>
      <img
        className={scss.finalScore}
        src={yourFinalScoreHeadline}
        alt="Your Final Score"
      />
      <TotalPoints {...{ score }} />

      <Squad squad={squad} />

      <section className={scss.scoreDetails}>
        <div className={scss.scoreTotals}>
          <div className={scss.scoreItem}>
            <div className={scss.imgWrapper}>
              <img src={heartIcon} alt="" />{" "}
            </div>
            <label>
              TOTAL
              <br />
              SURVIVAL TIME
            </label>
            <ScoreNumber number={score.totalSurvivalTime} />
          </div>
          <div className={scss.scoreItem}>
            <div className={scss.imgWrapper}>
              <img src={skullIcon} alt="" />{" "}
            </div>
            <label>
              TOTAL
              <br />
              KILL COUNT
            </label>
            <ScoreNumber number={score.totalKillCount} />
          </div>
        </div>
        {Object.keys(score.characters).map((characterId) => (
          <div key={characterId} className={scss.characterTotal}>
            {score.characters[characterId].achievements.map((a, i) => (
              <ScoreItem
                key={`${characterId}${a.category}${a.name}`}
                characterId={characterId}
                achievement={a}
                index={i}
              />
            ))}
          </div>
        ))}
      </section>
      <section className={scss.shareWrapper}>
        <button
          className={`roundedButton ${scss.roundedButton}`}
          onClick={() => history.push(`/share/${entryId}`)}
        >
          SHARE
        </button>
      </section>
    </main>
  );
};

export default WithMotion(YourScore);
